// Team-format (grade 3) group/bracket rows only carry the team's name, not
// its player roster (that lives on the team record itself - see
// fetchTeamRoster.js's own comment for the identical reasoning on the
// single-team lookup this complements). Search-chip matching needs every
// team's roster up front though, not one at a time on demand, so this pulls
// the same bulk teams/ listing TournamentPlayers.js already uses for its own
// full-roster search options and keys it by team name - the only identifier
// group/bracket rows and this listing both carry.
export async function fetchTeamRosterMap(api, tournamentId, limit) {
    const map = new Map();
    try {
        let res = await api.get(`/api/v1.0/tournaments/${tournamentId}/teams/?limit=${limit}`);
        // `limit` (usually tournament.player_quantity) is a registration
        // target, not a reliable count of teams actually registered - see
        // fetchPlayerNameMap.js's own identical comment. Refetch with the
        // response's own `count` whenever it says there's more.
        const total = res.data?.count;
        if (total && total > (res.data?.results?.length || 0)) {
            res = await api.get(`/api/v1.0/tournaments/${tournamentId}/teams/?limit=${total}`);
        }
        const teams = res.data?.results || res.data || [];
        teams.forEach(team => {
            if (team?.name) map.set(team.name, team.players || []);
        });
    } catch (e) {
        console.error("Failed to fetch team roster map:", e);
    }
    return map;
}
